var React = require('react');

function PayIconGreenInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"opacity":"0.7","cx":"12.5","cy":"12.5","r":"12.5","fill":"#DCFFEC","key":0}),React.createElement("path",{"d":"M10.0811 10.642C10.0811 8.56167 11.7675 6.87524 13.8478 6.87524C15.9281 6.87524 17.6145 8.56167 17.6145 10.642C17.6145 12.7223 15.9281 14.4087 13.8478 14.4087C11.7675 14.4087 10.0811 12.7223 10.0811 10.642Z","fill":"white","key":1}),React.createElement("path",{"d":"M12.7675 12.0989L9.31473 14.753L5.9375 13.3829L14.9777 9.88867L11.4835 18.9289L10.1133 15.5515L12.7675 12.0989Z","fill":"#48D38A","key":2})]);
}

PayIconGreenInline.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none"};

module.exports = PayIconGreenInline;

PayIconGreenInline.default = PayIconGreenInline;
